import type { RouteLocationNormalized } from 'vue-router';
import { api } from '@/api';
import { ValidateTokenRequestDtoTypeEnum } from '@/api/generator';
import { routenames } from '../routenames';

// Validate the activation token before the ActivationView mounts. Any failure
// (invalid/expired token, deleted account) redirects to sign-in without the
// "account activated" greeting, so the activation form never flashes.
export async function activationGuard(to: RouteLocationNormalized) {
  if (to.name !== routenames.activation) return;

  const { token, email } = to.params as { token: string; email: string };

  const { result } = await api.account.validateActivateUserToken({
    validateTokenRequestDto: {
      email,
      token,
      $type:
        ValidateTokenRequestDtoTypeEnum.PtwPtw100AppZeroApplicationSharedAuthorizationAccountDtoValidateTokenRequestDtoPtwPtw100AppZeroApplicationShared,
    },
  });

  if (!result?.result) {
    return {
      name: routenames.signOut,
      query: { dontShowGreetings: '1' },
    };
  }
}
